// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"f7","imgTextCardBox":"f7","text-box":"f8","textBox":"f8","remark-val":"f9","remarkVal":"f9"};